import React from 'react';
import { IconProps } from '../types';

export const ProductManagementIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.081 0.333252H1.66675V31.6666H13.0001V29.6666H3.66675V2.33325H17.6667V10.3333H25.6667V14.3333H27.6667V8.91904L19.081 0.333252ZM24.2525 8.33325L19.6667 3.74746V8.33325H24.2525Z"
            fill={color}
        />
        <path d="M7.00008 5.66658H11.6667V7.66658H7.00008V5.66658Z" fill={color} />
        <path d="M7.00008 9.66658H14.3334V11.6666H7.00008V9.66658Z" fill={color} />
        <path d="M11.6667 13.6666H7.00008V15.6666H11.6667V13.6666Z" fill={color} />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.6667 18.4122L21.9395 13.5486L13.6667 17.6849V26.921L23.4378 31.8065L31.6667 26.8692V18.4122ZM18.667 17.4209L16.9031 18.3029L23.3946 21.5486L25.1586 20.6667L18.667 17.4209ZM15.6667 19.9208V25.6849L22.3946 29.0489V23.2847L15.6667 19.9208ZM24.3946 28.9001L29.6667 25.7368V20.6486L24.3946 23.2847V28.9001ZM28.431 19.0304L27.3946 19.5486L20.9031 16.3029L21.9395 15.7847L28.431 19.0304Z"
            fill={color}
        />
    </svg>
);
